import { ComponentType } from "react";
import { Redirect } from "react-router-dom";
import Login from "../pages/login/Login";
import Pages401 from "../pages/Pages401";
import Products from "../pages/products/Products";
import EditProduct from "../pages/products/EditProduct";
import ViewProduct from "../pages/products/ViewProduct";
import ViewProductPage from "../pages/products/view/ViewProductPage";
import CreateProduct from "../pages/products/CreateProduct";
import Category from "../pages/category/Category";
import Dashboard from "../pages/dashboard/Dashboard";
import User from "../pages/users/User";
import Artform from "../pages/artform/Artform";
import Type from "../pages/type/Type";
import SubCategory from "../pages/sub-category/SubCategory";
import WeaveType from "../pages/weave-type/WeaveType";
import TypeTags from "../pages/type-tags/TypeTags";
import ProcessMaster from "../pages/process-master/ProcessMaster";
import CustomFields from "../pages/custom-fields/CustomFields";
import CareTemplates from "../pages/care/CareTemplates";
import ZohoBooksPage from "../pages/billing-sync/ZohoBooksPage";
import { isBillingSyncEnabled } from "../helpers/billingSyncEnabled";
import CareApplyToProducts from "../pages/care/CareApplyToProducts";
import CreateUserWithRoute from "../pages/users/CreateUserWithRoute";
import EditUser from "../pages/users/EditUser";
import ViewUser from "../pages/users/ViewUser";
import OrganizationProfile from "../pages/profile/OrganizationProfile";
import CompanyProfile from "../pages/profile/CompanyProfile";
import PreviewProduct from "../pages/products/PreviewProduct";
import ProductVerification from "../pages/products/ProductVerification";
import ViewUserProfile from "../pages/profile/ViewUserProfile";
import ProductApiFailed from "../pages/products/ProductApiFailed";
import ProductSuccessFlow from "../pages/products/certification-page/ProductSuccessFlow";
// revamp pages
// import ProductNewCertification from "../pages/products/certification-page/ProductNewCertification";
import ProductFakeAlert from "../pages/products/certification-page/ProductFakeAlert";
import ProductFakeAlertInfomation from "../pages/products/certification-page/ProductFakeAlertInfomation";
import ProductReportedPage from "../pages/products/certification-page/ProductReportedPage";
// import OtpVerify from "../pages/products/certification-page/OtpVerify";
import VerifyingProduct from "../pages/products/certification-page/VerifyingProduct";
import QRCodeProduct from "../pages/products/common components/QRCodeProduct";
import AuthenticatePage from "../pages/products/certification-page/AuthenticatePage";
import OrganizationParent from "../pages/organisations/OrganizationParent";
import SuperAdminOrganisationPage from "../pages/organisations/SuperAdminOrganisationPage";
import StudioModulesPage from "../pages/studio-modules/StudioModulesPage";
import ManufacturerParent from "../pages/organisations/ManufacturerParent";
// import DesignAgency from "../pages/organisations/DesignAgency";
import { ProductSomethingWentToWrong } from "../pages/products/certification-page/ProductSomethingWentToWrong";
// import ProductCertificationForDesignAgency from "../pages/products/certification-page/ProductCertificationForDesignAgency";
import ProductCertificationTantuvi from "../pages/products/ProductCertificationTantuvi";
import ProductCertificationTantuviPreview from "../pages/products/ProductCertificationTantuviPreview";
import EditProfileOrganizationDetails from "../pages/profile/EditProfileOrganizationDetails";
import ExpiryLinkPage from "../pages/products/ExpiryLinkPage";
import CapturePublicPage from "../pages/products/capture/CapturePublicPage";
import ShadeUploadPage from "../pages/products/shade/ShadeUploadPage";
import PartnerLinkPage from "../pages/partner-link/PartnerLinkPage";
import PartnerInvitePage from "../pages/partner-link/PartnerInvitePage";
import PartnerLoginPage from "../pages/partner-link/PartnerLoginPage";
import PartnersPage from "../pages/partner-network/PartnersPage";
import ProductionBoard from "../pages/partner-network/ProductionBoard";
import NewProductionOrderPage from "../pages/partner-network/NewProductionOrderPage";
import ProductionOrderPage from "../pages/partner-network/ProductionOrderPage";
import IncomingOrdersPage from "../pages/partner-network/IncomingOrdersPage";
import { isPartnerNetworkEnabled } from "../helpers/partnerNetworkEnabled";
import { UIDErrorPage } from "../pages/products/certification-page/UIDErrorPage";
import ForgetPassword from "../pages/login/ForgetPassword";
import ResetPassword from "../pages/login/ResetPassword";
import StudioSignup from "../pages/login/StudioSignup";
import HomePage from "../pages/website/site/HomePage";
import CollectorsPage from "../pages/website/site/CollectorsPage";
import StudioPage from "../pages/website/site/StudioPage";
import TermsAndConditions from "../pages/website/components/TermsAndConditions";
import PrivacyPolicy from "../pages/website/components/PrivacyPolicy";
import PricingPage from "../pages/website/site/PricingPage";
// catalog
import Catalog from "../pages/catalog/Catalog";
import ViewCatalogProducts from "../pages/catalog/ViewCatalogProducts";
import PreviewECommerce from "../pages/catalog/ecomerce/PreviewECommerce";
import PublicCatalogueEcomerce from "../pages/catalog/ecomerce/PublicCatalogueEcomerce";
import OpenPieceLink from "../pages/catalog/ecomerce/OpenPieceLink";
import ProductInformation from "../pages/catalog/ecomerce/ProductInformation";
import PublicCatalogueProductInfo from "../pages/catalog/ecomerce/PublicCatalogueProductInfo";
import PublicCatalogueVisitorAccount from "../pages/catalog/ecomerce/PublicCatalogueVisitorAccount";
import PublicCatalogueVisitorSubmitted from "../pages/catalog/ecomerce/PublicCatalogueVisitorSubmitted";
// catalogue manager
import CatalogueManagerPage from "../pages/catalogue-manager/CatalogueManagerPage";
import CatalogueAddFromInventoryPage from "../components/catalogue/CatalogueAddFromInventoryPage";
import CollectorTagStock from "../pages/my-collection/CollectorTagStock";
import MyCollectionDashboard from "../pages/my-collection/MyCollectionDashboard";
import CollectorLoginPage from "../pages/my-collection/CollectorLoginPage";
import AddExternalPiece from "../pages/my-collection/AddExternalPiece";
import PublicPiecePage from "../pages/my-collection/PublicPiecePage";
import MyCollectionSettings from "../pages/my-collection/MyCollectionSettings";
import MyCollectionItemDetail from "../pages/my-collection/MyCollectionItemDetail";
import UpgradePage from "../pages/my-collection/UpgradePage";
import MyCollectionHelp from "../pages/my-collection/MyCollectionHelp";
import HowToScan from "../pages/my-collection/HowToScan";
import CollectorUnavailable from "../pages/my-collection/CollectorUnavailable";
import StudioAccessRequests from "../pages/my-collection/StudioAccessRequests";
import { isCollectorEnabled } from "../helpers/collectorSession";
import GiRegistryList from "../pages/gi-registry/GiRegistryList";
import HkpNfcTags from "../pages/nfc-tags/HkpNfcTags";
import GiRegistryForm from "../pages/gi-registry/GiRegistryForm";
import GiAuthorisedUserForm from "../pages/gi-registry/GiAuthorisedUserForm";
import IdentityResolverPage from "../pages/physical-identity/IdentityResolverPage";
import IdentityDashboard from "../pages/physical-identity/IdentityDashboard";
import LabelPoolPage from "../pages/physical-identity/LabelPoolPage";
import StageListEditor from "../pages/physical-identity/StageListEditor";
import PhysicalLoomRoute from "../pages/physical-identity/PhysicalLoomRoute";
import PublicLoomPage from "../pages/looms/PublicLoomPage";
import CertificationsList from "../pages/certifications/CertificationsList";
import CertificationForm from "../pages/certifications/CertificationForm";
import OrdersList from "../pages/orders/OrdersList";
import OrderForm from "../pages/orders/OrderForm";
import OrderConfirmPage from "../pages/orders/OrderConfirmPage";
import OrderApprovalPage from "../pages/orders/approval/OrderApprovalPage";
import OrderApprovalSettingsPage from "../pages/orders/approval/OrderApprovalSettingsPage";
import SalesAddProductsPage from "../pages/sales/SalesAddProductsPage";
import { SalesHubResponsive, SalesMemoResponsive } from "../pages/sales/phone/SalesResponsive";
import SalesTakeBack from "../pages/sales/SalesTakeBack";
import StudioPieceQrPage from "../pages/sales/StudioPieceQrPage";
import KarkhanaHome from "../pages/karkhana/KarkhanaHome";
import KarkhanaDailyWorkPage from "../pages/karkhana/KarkhanaDailyWorkPage";
import KarkhanaAttendancePage from "../pages/karkhana/KarkhanaAttendancePage";
import KarkhanaPayPage from "../pages/karkhana/KarkhanaPayPage";
import KarkhanaHistoryImportPage from "../pages/karkhana/KarkhanaHistoryImportPage";
import KarkhanaReportsPage from "../pages/karkhana/KarkhanaReportsPage";
import CashBookRoute from "../pages/karkhana/cashbook/CashBookRoute";
import CashCamera from "../pages/karkhana/cashbook/supervisor/CashCamera";
import SpendForm from "../pages/karkhana/cashbook/supervisor/SpendForm";
import EntryDetail from "../pages/karkhana/cashbook/supervisor/EntryDetail";
import GiveCash from "../pages/karkhana/cashbook/transfer/GiveCash";
import TransferDetail from "../pages/karkhana/cashbook/transfer/TransferDetail";
import CashSheetPrintPage from "../pages/karkhana/cashbook/print/CashSheetPrintPage";
import SheetCheck from "../pages/karkhana/cashbook/owner/SheetCheck";
import SpendsCheck from "../pages/karkhana/cashbook/owner/SpendsCheck";
import WorkerPaymentCard from "../pages/karkhana/cashbook/owner/WorkerPaymentCard";
import CheckedHistory from "../pages/karkhana/cashbook/owner/CheckedHistory";
import SpendTypes from "../pages/karkhana/cashbook/owner/SpendTypes";
import HolderDay from "../pages/karkhana/cashbook/owner/HolderDay";
import KarkhanaJobWorkPage from "../pages/karkhana/KarkhanaJobWorkPage";
import KarkhanaSettingsPage from "../pages/karkhana/KarkhanaSettingsPage";
import KarkhanaGuidePage from "../pages/karkhana/KarkhanaGuidePage";
import KarkhanaSareeHistoryPage from "../pages/karkhana/KarkhanaSareeHistoryPage";
import KarkhanaLoomHistoryPage from "../pages/karkhana/KarkhanaLoomHistoryPage";
import KarkhanaSareesPage from "../pages/karkhana/KarkhanaSareesPage";
import KarkhanaPaySheetsPage from "../pages/karkhana/KarkhanaPaySheetsPage";
import KarkhanaOpeningBalancesPage from "../pages/karkhana/KarkhanaOpeningBalancesPage";
import KarkhanaPaySheetPage from "../pages/karkhana/KarkhanaPaySheetPage";
import KarkhanaWorkTypesPage from "../pages/karkhana/KarkhanaWorkTypesPage";
import KarkhanaDesignsPage from "../pages/karkhana/KarkhanaDesignsPage";
import KarkhanaWorkersPage from "../pages/karkhana/KarkhanaWorkersPage";
import KarkhanaWorkerCategoriesPage from "../pages/karkhana/KarkhanaWorkerCategoriesPage";
import KarkhanaWorkerImportPage from "../pages/karkhana/KarkhanaWorkerImportPage";
import KarkhanaImportPage from "../pages/karkhana/KarkhanaImportPage";
import KarkhanaWorkerReviewPage from "../pages/karkhana/KarkhanaWorkerReviewPage";
import KarkhanaRateCardsPage from "../pages/karkhana/KarkhanaRateCardsPage";
import KarkhanaRateImportPage from "../pages/karkhana/KarkhanaRateImportPage";
import KarkhanaRateCardPage from "../pages/karkhana/KarkhanaRateCardPage";
import KarkhanaTimeRatesPage from "../pages/karkhana/KarkhanaTimeRatesPage";
import KarkhanaRoundsPage from "../pages/karkhana/KarkhanaRoundsPage";
import KarkhanaApprovalsPage from "../pages/karkhana/KarkhanaApprovalsPage";
import KarkhanaSupervisorsPage from "../pages/karkhana/KarkhanaSupervisorsPage";
import KarkhanaCostingsPage from "../pages/karkhana/KarkhanaCostingsPage";
import KarkhanaCostingPage from "../pages/karkhana/KarkhanaCostingPage";
import KarkhanaCostingSetupPage from "../pages/karkhana/KarkhanaCostingSetupPage";
import KarkhanaSupervisorLoginPage from "../pages/karkhana/supervisor/KarkhanaSupervisorLoginPage";
import KarkhanaMorePage from "../pages/karkhana/KarkhanaMorePage";
import KarkhanaWorkerPhotosPage from "../pages/karkhana/KarkhanaWorkerPhotosPage";
import { KARKHANA_PAGES, KarkhanaPageKey, KP } from "../pages/karkhana/karkhanaPaths";
import { karkhanaLegacyRoutes } from "./karkhanaLegacyRoutes";

const KARKHANA_COMPONENTS: Record<KarkhanaPageKey, ComponentType<any>> = {
  home: KarkhanaHome,
  more: KarkhanaMorePage,
  settings: KarkhanaSettingsPage,
  rounds: KarkhanaRoundsPage,
  dailyWork: KarkhanaDailyWorkPage,
  attendance: KarkhanaAttendancePage,
  jobWork: KarkhanaJobWorkPage,
  sarees: KarkhanaSareesPage,
  saree: KarkhanaSareeHistoryPage,
  approvals: KarkhanaApprovalsPage,
  loom: KarkhanaLoomHistoryPage,
  pay: KarkhanaPayPage,
  paySheets: KarkhanaPaySheetsPage,
  payOpenings: KarkhanaOpeningBalancesPage,
  paySheet: KarkhanaPaySheetPage,
  cashBook: CashBookRoute,
  cashCamera: CashCamera,
  cashSpend: SpendForm,
  cashEntry: EntryDetail,
  cashGive: GiveCash,
  cashTransfer: TransferDetail,
  cashPrint: CashSheetPrintPage,
  cashCheck: SheetCheck,
  cashSpendsCheck: SpendsCheck,
  cashWorker: WorkerPaymentCard,
  cashHistory: CheckedHistory,
  cashHeads: SpendTypes,
  cashHolder: HolderDay,
  costings: KarkhanaCostingsPage,
  costing: KarkhanaCostingPage,
  workers: KarkhanaWorkersPage,
  workerImport: KarkhanaWorkerImportPage,
  workerPhotos: KarkhanaWorkerPhotosPage,
  workerReview: KarkhanaWorkerReviewPage,
  supervisors: KarkhanaSupervisorsPage,
  codes: KarkhanaWorkerCategoriesPage,
  designs: KarkhanaDesignsPage,
  rateCards: KarkhanaRateCardsPage,
  rateImport: KarkhanaRateImportPage,
  rateCard: KarkhanaRateCardPage,
  timeRates: KarkhanaTimeRatesPage,
  parts: KarkhanaWorkTypesPage,
  costingLines: KarkhanaCostingSetupPage,
  import: KarkhanaImportPage,
  oldSheet: KarkhanaHistoryImportPage,
  reports: KarkhanaReportsPage,
  guide: KarkhanaGuidePage,
};


const collectorPublicRoutes = isCollectorEnabled()
  ? [
      { path: "/collectors", exact: true, component: CollectorsPage },
      { path: "/my-collection/about", exact: true, component: CollectorsPage },
      { path: "/my-collection/login", exact: true, component: CollectorLoginPage },
      { path: "/my-collection/tags", exact: true, component: CollectorTagStock },
      { path: "/my-collection/add", exact: true, component: AddExternalPiece },
      { path: "/my-collection/upgrade", exact: true, component: UpgradePage },
      { path: "/my-collection/settings", exact: true, component: MyCollectionSettings },
      { path: "/my-collection/help", exact: true, component: MyCollectionHelp },
      { path: "/my-collection/how-to-scan", exact: true, component: HowToScan },
      { path: "/my-collection/scanned", exact: true, component: MyCollectionDashboard },
      { path: "/my-collection/item/:itemId", exact: true, component: MyCollectionItemDetail },
      { path: "/my-collection/piece/:collectorItemId", exact: true, component: PublicPiecePage },
      { path: "/my-collection", exact: true, component: MyCollectionDashboard },
    ]
  : [
      { path: "/my-collection", exact: true, component: CollectorUnavailable },
    ];

const publicRoutes = [
  { path: "/home", exact: true, component: HomePage },
  { path: "/studio", exact: true, component: StudioPage },
  { path: "/studio/p/:productId", exact: true, component: StudioPieceQrPage },
  { path: "/studio/signup", exact: true, component: StudioSignup },
  { path: "/login", exact: true, component: Login },
  // Supervisors' private sign-in link (sent by the studio; not linked from the public site).
  { path: KP.login, exact: true, component: KarkhanaSupervisorLoginPage },
  { path: "/orders/confirm/:token", exact: true, component: OrderConfirmPage },
  // Customer approval links: /a/<token> is the short link; /order-approval/<token> is where the
  // link-preview page sends people on UAT (nginx gives WhatsApp the preview first).
  { path: "/a/:token", exact: true, component: OrderApprovalPage },
  { path: "/order-approval/:token", exact: true, component: OrderApprovalPage },
  { path: "/pages-401", exact: true, component: Pages401 },
  { path: "/forget-password", exact: true, component: ForgetPassword },
  { path: "/reset-password", exact: true, component: ResetPassword },
  // { path: "/registerUser", exact: true, component: CreateUser },
  {
    path: "/product-certification/:productId",
    exact: true,
    component: ProductVerification,
  },
  {
    path: "/product-certification",
    exact: true,
    component: ProductVerification,
  },
  {
    path: "/product-verifing/:productId",
    exact: true,
    component: VerifyingProduct,
  },
  {
    path: "/product-verifing",
    exact: true,
    component: VerifyingProduct,
  },
  {
    path: "/authentication-page/:productId",
    exact: true,
    component: AuthenticatePage,
  },
  {
    path: "/authentication-page",
    exact: true,
    component: AuthenticatePage,
  },
  {
    path: "/user-deatails/:expiry/:productId",
    exact: true,
    component: ProductSuccessFlow,
  },
  {
    path: "/user-deatails/:productId",
    exact: true,
    component: ProductSuccessFlow,
  },
  { path: "/user-deatails", exact: true, component: ProductSuccessFlow },
  { path: "/terms-and-conditions", exact: true, component: TermsAndConditions },
  ...collectorPublicRoutes,
  { path: "/privacy-policy", exact: true, component: PrivacyPolicy },
  { path: "/pricing", exact: true, component: PricingPage },

  // {
  //   path: "/otp-verifying",
  //   exact: true,
  //   component: OtpVerify,
  // },

  { path: "/fake-alert", exact: true, component: ProductFakeAlert },
  {
    path: "/product-fake-alert-user-information",
    exact: true,
    component: ProductFakeAlertInfomation,
  },
  {
    path: "/product-reported",
    exact: true,
    component: ProductReportedPage,
  },
  {
    path: "/product-not-mapped-error",
    exact: true,
    component: UIDErrorPage,
  },

  {
    path: "/page-failed",
    exact: true,
    component: ProductApiFailed,
  },
  {
    path: "/page-error",
    exact: true,
    component: ProductSomethingWentToWrong,
  },
  //revamp pages
  {
    path: "/product-certification-new/:expiry/:productId",
    exact: true,
    component: QRCodeProduct,
  },
  {
    path: "/product-certification-new/:productId",
    exact: true,
    component: QRCodeProduct,
  },
  {
    path: "/product-certification-new",
    exact: true,
    component: QRCodeProduct,
  },
  {
    path: "/product-certification-tantuvi-new/:productId",
    exact: true,
    component: ProductCertificationTantuvi,
  },
  {
    path: "/product-certification-tantuvi-new",
    exact: true,
    component: ProductCertificationTantuvi,
  },
  {
    path: "/product-link-expired",
    exact: true,
    component: ExpiryLinkPage,
  },
  { path: "/capture/:token", exact: true, component: CapturePublicPage },
  // Worker shade-photo link; the backend answers "not valid" while photo updates are off.
  { path: "/shade/:token", exact: true, component: ShadeUploadPage },
  // Partner network (flag off = these routes don't exist).
  ...(isPartnerNetworkEnabled()
    ? [
        { path: "/p/:token", exact: true, component: PartnerLinkPage },
        { path: "/partner-invite/:token", exact: true, component: PartnerInvitePage },
        { path: "/partner-login", exact: true, component: PartnerLoginPage },
      ]
    : []),
  { path: "/loom/:code", exact: true, component: PublicLoomPage },
  { path: "/q/:token", exact: true, component: IdentityResolverPage },
  { path: "/catalogue-products/:id", exact: true, component: PublicCatalogueEcomerce },
  { path: "/catalogue/:id", exact: true, component: PublicCatalogueEcomerce },
  { path: "/catalogue-product-info/:id", exact: true, component: PublicCatalogueProductInfo },
  // Short piece links from "Ask on WhatsApp"; UAT's nginx serves /w/ with a preview first.
  { path: "/w/:code", exact: true, component: OpenPieceLink },
  { path: "/open-piece/:code", exact: true, component: OpenPieceLink },
  { path: "/catalogue-visitor/account", exact: true, component: PublicCatalogueVisitorAccount },
  {
    path: "/catalogue-visitor/submitted",
    exact: true,
    component: PublicCatalogueVisitorSubmitted,
  },


  // {
  //   path: "/product-certification-new1",
  //   exact: true,
  //   component: ProductCertificationForDesignAgency,
  // },
];
const privateRoutes = [
  { path: "/gi-registry/new", exact: true, component: GiRegistryForm },
  { path: "/gi-registry/:id/authorised-user", exact: true, component: GiAuthorisedUserForm },
  { path: "/gi-registry/:id/edit", exact: true, component: GiRegistryForm },
  { path: "/gi-registry/:id", exact: true, component: GiRegistryForm },
  { path: "/gi-registry", exact: true, component: GiRegistryList },
  { path: "/physical-identities", exact: true, component: IdentityDashboard },
  { path: "/physical-identities/label-pool", exact: true, component: LabelPoolPage },
  { path: "/physical-identities/stages", exact: true, component: StageListEditor },
  { path: "/looms/new", exact: true, component: PhysicalLoomRoute },
  { path: "/looms/:id/edit", exact: true, component: PhysicalLoomRoute },
  { path: "/looms/:id", exact: true, component: PhysicalLoomRoute },
  { path: "/looms", exact: true, component: PhysicalLoomRoute },
  { path: "/certifications/new", exact: true, component: CertificationForm },
  { path: "/certifications/:id/edit", exact: true, component: CertificationForm },
  { path: "/certifications/:id", exact: true, component: CertificationForm },
  { path: "/certifications", exact: true, component: CertificationsList },
  { path: "/orders/approval-settings", exact: true, component: OrderApprovalSettingsPage },
  { path: "/orders/new", exact: true, component: OrderForm },
  { path: "/orders/:id/edit", exact: true, component: OrderForm },
  { path: "/orders/:id", exact: true, component: OrderForm },
  { path: "/orders", exact: true, component: OrdersList },
  { path: "/sales/memos/new", exact: true, component: SalesMemoResponsive },
  { path: "/sales/memos/:id/add-products", exact: true, component: SalesAddProductsPage },
  { path: "/sales/memos/:id", exact: true, component: SalesMemoResponsive },
  { path: "/sales/credit/new", exact: true, component: SalesMemoResponsive },
  { path: "/sales/approval/new", exact: true, component: SalesMemoResponsive },
  { path: "/sales/take-back", exact: true, component: SalesTakeBack },
  { path: "/sales", exact: true, component: SalesHubResponsive },
  // Karkhana: one address map (karkhanaPaths.ts), routes in its order.
  ...KARKHANA_PAGES.map((p) => ({ path: KP[p.key], exact: true, component: KARKHANA_COMPONENTS[p.key] })),
  { path: "/products", exact: true, component: Products },
  { path: "/collector-access-requests", exact: true, component: StudioAccessRequests },
  { path: "/edit-product/:id", exact: true, component: EditProduct },
  { path: "/view-product/:id", exact: true, component: ViewProduct },
  { path: "/product/:id", exact: true, component: ViewProductPage },
  { path: "/createProduct", exact: true, component: CreateProduct },
  { path: "/dashboard", exact: true, component: Dashboard },
  { path: "/users", exact: true, component: User },
  { path: "/createUser", exact: true, component: CreateUserWithRoute },
  { path: "/editUser/:id", exact: true, component: EditUser },
  { path: "/viewUser/:id", exact: true, component: ViewUser },
  { path: "/category", exact: true, component: Category },
  { path: "/sub-category", exact: true, component: SubCategory },
  { path: "/type", exact: true, component: Type },
  { path: "/artform", exact: true, component: Artform },
  { path: "/weave-type", exact: true, component: WeaveType },
  { path: "/type-tags", exact: true, component: TypeTags },
  { path: "/process-master", exact: true, component: ProcessMaster },
  { path: "/custom-fields", exact: true, component: CustomFields },
  { path: "/care-templates", exact: true, component: CareTemplates },
  { path: "/care-templates/:id/apply", exact: true, component: CareApplyToProducts },
  { path: "/organisation/:id", exact: true, component: SuperAdminOrganisationPage },
  { path: "/organisation", exact: true, component: OrganizationParent },
  { path: "/studio/modules", exact: true, component: StudioModulesPage },
  ...(isBillingSyncEnabled() ? [{ path: "/settings/zoho-books", exact: true, component: ZohoBooksPage }] : []),
  { path: "/nfc-tags", exact: true, component: HkpNfcTags },
  { path: "/profile", exact: true, component: OrganizationProfile },
  {
    path: "/edit-profile-user-details",
    exact: true,
    component: CompanyProfile,
  },
  {
    path: "/edit-profile-organisation-details",
    exact: true,
    component: EditProfileOrganizationDetails,
  },

  { path: "/view-user-profile", exact: true, component: ViewUserProfile },
  { path: "/pre-viewProduct/:id", exact: true, component: PreviewProduct },
  {
    path: "/pre-ViewProduct-tantuvi/:id",
    exact: true,
    component: ProductCertificationTantuviPreview,
  },
  { path: "/party", exact: true, component: ManufacturerParent },
  // { path: "/manufactures", exact: true, component: DesignAgency },
  //catalog
  {
    path: "/catalogue/:catalogueId/add-from-inventory",
    exact: true,
    component: CatalogueAddFromInventoryPage,
  },
  { path: "/catalogue", exact: true, component: CatalogueManagerPage },
  ...(isPartnerNetworkEnabled()
    ? [
        { path: "/partner-network/partners", exact: true, component: PartnersPage },
        { path: "/partner-network/board", exact: true, component: ProductionBoard },
        { path: "/partner-network/orders/new", exact: true, component: NewProductionOrderPage },
        { path: "/partner-network/orders/:id", exact: true, component: () => <ProductionOrderPage side="PRINCIPAL" /> },
        { path: "/partner-network/incoming", exact: true, component: IncomingOrdersPage },
        { path: "/partner-network/incoming/:id", exact: true, component: () => <ProductionOrderPage side="PARTNER" /> },
      ]
    : []),
  { path: "/catalogue-old", exact: true, component: Catalog },
  { path: "/view-catalogue-products/:id", exact: true, component: ViewCatalogProducts },
  { path: "/pre-view-catalogue-products/:id", exact: true, component: PreviewECommerce },
  { path: "/product-info/:id", exact: true, component: ProductInformation },
  {
    path: "/",
    exact: true,
    component: () => <Redirect to="/dashboard" />,
  },
];
export { publicRoutes, privateRoutes, karkhanaLegacyRoutes };

